import { OrderSearch } from "../../../objects/responses/orderSearch";
import { OrderService } from "../../../services/orderService";
import { CustomerService } from "../../../services/customerService";
import { UserService } from "../../../services/userService";
import { PaginationInstance } from "ngx-pagination";
import { OrderSearchRequest } from "../../../objects/requests/orderSearchRequest";
import { Order } from "../../../objects/orders/order";
import { Location } from '@angular/common';
import { CalculatorHelper } from "../../../common/helpers/calculatorHelper";
import { OrderViewType } from "../../../objects/management/order/orderViewType";
import { StorageManager } from "../../../common/managers/storageManager";
import { Column, SortType, User } from "../../../objects/users/user";
import { UserViewService } from "../../../services/userViewService";
import { OrderODataService } from "../../../services/orderOData.service";
import { Component as ComponentEnum, Component } from "../../../objects/components/component";
import { OrderBy } from "ngx-odata-v4";
import { UserViewHelper } from "../../../common/helpers/userViewHelper";

/**
 * Created by svitlana.i on 10/10/2017.
 */
export class BaseOrderManagement {

    public config: PaginationInstance = {
        id: 'custom',
        itemsPerPage: 12,
        currentPage: 1,
        totalItems: 1
    };

    public agentId?: number = null;
    public customerId?: number = null;
    public query: string = "";
    public orders: Order[] = [];
    public isLoading: boolean = false;
    public isViewLoading: boolean = false;

    public currentUser: User | null = null;

    public isTableShown = true;

    constructor(public orderService: OrderService, public location: Location, public customerService: CustomerService
        , public userService: UserService, public storageManager: StorageManager, public userViewService: UserViewService, public orderODataService: OrderODataService) {
        storageManager.getCurrentUser().then((user: User) => {
            this.currentUser = user;
        });
    }

    public getSearchParams(): OrderSearch {
        let result = new OrderSearch();

        result.AgentId = this.agentId;
        result.Query = this.query;
        result.CustomerID = this.customerId;
        return result;
    }

    public tableColumns: any[] = [];

    public getColumns(viewType: OrderViewType = null): any[] {
        return UserViewHelper.getColumns(this.userViewService, Component.OrderManagement, viewType)
    }

    public get currentView() {
        if (this.userViewService.userView)
            return this.userViewService.userView[ComponentEnum.OrderManagement].ViewType;

        return OrderViewType.Tile;
    }

    public search(removeAgentId: boolean = true, redirectURL: string = "/management/order", isLazyLoad: boolean = false, showSpinner = true): Promise<Order[]> | null {
        
        const isOrderManagement = redirectURL == "/management/order";

        let top = (this.currentView == OrderViewType.Table) && isOrderManagement ? 20 : this.config.itemsPerPage;

        let orderBy: any = UserViewHelper.getColumnOrderBy(this.userViewService.userView, Component.OrderManagement);

        this.isLoading = true;
        this.isViewLoading = !isLazyLoad && showSpinner;

        if (removeAgentId) {
            this.location.replaceState(redirectURL);
            this.agentId = null;

            let searchQuery: string = CalculatorHelper.replaceOrderPrefix(this.query);

            return this.orderService.search(new OrderSearchRequest({
                Skip: (this.config.currentPage - 1) * this.config.itemsPerPage,
                Top: top,
                Query: searchQuery,
                OrderBy: orderBy
            })).then((orders: any) => this.searchResolve(orders, isLazyLoad))
                .catch((reject) => this.searchReject(reject));
        }
        else if (this.agentId) {

            return this.orderODataService.getOrdersByAgentId(this.agentId, (this.config.currentPage - 1) * this.config.itemsPerPage, top, orderBy)
                .then((orders: any) => this.searchResolve(orders, isLazyLoad))
                .catch((reject) => this.searchReject(reject));
        }
        else {
            return this.orderODataService.getByCustomerId(this.customerId, (this.config.currentPage - 1) * this.config.itemsPerPage, top, orderBy)
                .then((orders: any) => this.searchResolve(orders, isLazyLoad))
                .catch((reject) => this.searchReject(reject));
        }
    }

    private searchResolve(orders: any, isLazyLoad: boolean = false): Order[] {
        if (this.currentView == OrderViewType.Table && isLazyLoad) {
            this.orders.push(...orders.Items);
            this.orders = [...this.orders]; // need for ngx-data-table detect changes!!!!
        }
        else {
            this.orders = orders.Items;
        }

        this.config.totalItems = orders.TotalCount;

        document.getElementById('mainPanel').scrollTop = 0;
        this.isLoading = false;
        this.isViewLoading = false;
        this.isTableShown = true;
        return this.orders;
    }

    private searchReject(reject: any): Order[] {
        this.orders.splice(0, this.orders.length);
        this.isViewLoading = false;
        this.isLoading = false;
        return this.orders;
    }

}



// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/baseOrderManagement.ts